import { AnyAction } from '@reduxjs/toolkit';
import {
  COMPANY_CHANGED,
  SET_IS_FORM_VALID,
  SET_ARE_ALL_FIELDS_TOUCHED,
  SET_TOUCHED_QUESTION_NAME,
  RESET_TOUCHED_QUESTION_NAMES,
  SET_MODEL_NOT_FOUND,
  SET_MANUALLY_CHANGED_QUESTION_NAMES,
  RESET_MANUALLY_CHANGED_QUESTION_NAMES,
  SET_INCLUDE_BOM_ITEMS,
  RESET_MANUALLY_CLEARED_QUESTION_NAMES,
  SET_MANUALLY_CLEARED_QUESTION_NAMES,
} from '../../constants';

export interface IFormReducerState {
  isFormValid: boolean;
  areAllFieldsTouched: boolean;
  touchedQuestionNames: string[];
  manuallyChangedQuestionNames: string[];
  manuallyClearedQuestionNames: string[];
  modelNotFound: boolean;
  includeBomItems: boolean;
}

const INIT_STATE: IFormReducerState = {
  modelNotFound: false,
  isFormValid: false,
  areAllFieldsTouched: false,
  touchedQuestionNames: [],
  manuallyChangedQuestionNames: [],
  manuallyClearedQuestionNames: [],
  includeBomItems: false,
};

const formReducer = (state = INIT_STATE, action: AnyAction) => {
  switch (action.type) {
    case SET_TOUCHED_QUESTION_NAME: {
      if (state.touchedQuestionNames.includes(action.payload)) {
        return { ...state };
      } else {
        const touchedQuestionNames = [
          ...state.touchedQuestionNames,
          action.payload,
        ];
        return {
          ...state,
          touchedQuestionNames: touchedQuestionNames,
        };
      }
    }
    case SET_MANUALLY_CHANGED_QUESTION_NAMES: {
      if (state.manuallyChangedQuestionNames.includes(action.payload)) {
        return { ...state };
      } else {
        const manuallyChangedQuestionNames = [
          ...state.manuallyChangedQuestionNames,
          action.payload,
        ];
        return {
          ...state,
          manuallyChangedQuestionNames: manuallyChangedQuestionNames,
        };
      }
    }
    case RESET_MANUALLY_CHANGED_QUESTION_NAMES:
      return {
        ...state,
        manuallyChangedQuestionNames: [],
      };
    case SET_MANUALLY_CLEARED_QUESTION_NAMES: {
      if (state.manuallyClearedQuestionNames.includes(action.payload)) {
        return { ...state };
      } else {
        const manuallyClearedQuestionNames = [
          ...state.manuallyClearedQuestionNames,
          action.payload,
        ];
        return {
          ...state,
          manuallyClearedQuestionNames: manuallyClearedQuestionNames,
        };
      }
    }
    case RESET_MANUALLY_CLEARED_QUESTION_NAMES:
      return {
        ...state,
        manuallyClearedQuestionNames: [],
      };
    case RESET_TOUCHED_QUESTION_NAMES:
      return {
        ...state,
        touchedQuestionNames: [],
      };
    case SET_ARE_ALL_FIELDS_TOUCHED:
      return {
        ...state,
        areAllFieldsTouched: action.payload,
      };
    case SET_IS_FORM_VALID:
      return {
        ...state,
        isFormValid: action.payload,
      };
    case SET_MODEL_NOT_FOUND:
      return {
        ...state,
        modelNotFound: action.payload,
      };
    case COMPANY_CHANGED:
      // Validity and touched fields describe the model that was open.
      return {
        ...INIT_STATE,
      };
    case SET_INCLUDE_BOM_ITEMS:
      return {
        ...state,
        includeBomItems: action.payload,
      };

    default:
      return state;
  }
};

export default formReducer;
